export const CSRF_TOKEN_HEADER = "x-csrf-token";

// Supported feature flags

export const BETA_FLAG = "BETA__216615";
export const LEO_AI_LATEST_FLAG = "CHAT_AI__LEO_AI_LATEST__226561";
export const MARKET_RESEARCH_APP_FLAG = "MARKET_RESEARCH__APP__225996";
export const PROFILE_CREATION_FLAG = "CHAT_AI__PROFILE_CREATION__225532";
export const FLAKEGRAPH_PLUGIN_FLAG = "FLAKEGRAPH_PLUGIN__223106";
export const FeatureFlag = [
  BETA_FLAG,
  "TRAINING_AI__APP__189322",
  "SHAREPOINT_AI__APP__15085",
  "IMAGE_AI__IMAGE_EDIT_MASK__202290",
  "ROLEPLAY_AI_VOICE__207838",
  "REALTIME_CHAT_BETA__205478",
  "SNOW_FLAKE__199912",
  "RESEARCH_AI__APP__205402",
  "AGENT_AI__APP__219103",
  "CALENDAR_PLUGIN__221745",
  "ISEARCH_AI_COLUMNS__213673",
  "EXTERNAL_AI__223473",
  "METRICS_AI__APP__223356",
  "HTML_VIEWER__APP__222723",
  LEO_AI_LATEST_FLAG,
  MARKET_RESEARCH_APP_FLAG,
  PROFILE_CREATION_FLAG,
  FLAKEGRAPH_PLUGIN_FLAG,
] as const;
export type FeatureFlagType = (typeof FeatureFlag)[number];

// Features that the Beta flag grants access to.
// Any feature not listed here requires its own explicit flag.
export const BETA_INCLUDED_FEATURES: FeatureFlagType[] = [
  "TRAINING_AI__APP__189322",
  "SHAREPOINT_AI__APP__15085",
  "IMAGE_AI__IMAGE_EDIT_MASK__202290",
  "ROLEPLAY_AI_VOICE__207838",
  "REALTIME_CHAT_BETA__205478",
  "SNOW_FLAKE__199912",
  "RESEARCH_AI__APP__205402",
  "AGENT_AI__APP__219103",
  "ISEARCH_AI_COLUMNS__213673",
  "EXTERNAL_AI__223473",
];

// Map to print feature flags
export const featuresMap: { [key in FeatureFlagType]: string } = {
  BETA__216615: "Beta",
  TRAINING_AI__APP__189322: "Training AI",
  SHAREPOINT_AI__APP__15085: "SharePoint profile sync",
  IMAGE_AI__IMAGE_EDIT_MASK__202290: "Image AI edit mask UI",
  ROLEPLAY_AI_VOICE__207838: "Roleplay AI Voice",
  REALTIME_CHAT_BETA__205478: "Realtime Chat Beta",
  SNOW_FLAKE__199912: "Snow Flake Plugin",
  RESEARCH_AI__APP__205402: "Research AI App",
  AGENT_AI__APP__219103: "Agent AI App",
  CALENDAR_PLUGIN__221745: "Calendar Plugin",
  ISEARCH_AI_COLUMNS__213673: "iSearch AI Columns",
  EXTERNAL_AI__223473: "External AI",
  METRICS_AI__APP__223356: "Metrics AI",
  HTML_VIEWER__APP__222723: "HTML Viewer",
  CHAT_AI__LEO_AI_LATEST__226561: "LEO AI Latest",
  MARKET_RESEARCH__APP__225996: "Market Research",
  CHAT_AI__PROFILE_CREATION__225532: "Profile creation from chat",
  FLAKEGRAPH_PLUGIN__223106: "FlakeGraph Plugin",
};

// Workspace ID Header key
export const WORKSPACE_ID_HEADER = "X-Workspace-Id";
export const TRPC_MAX_BATCH_ITEMS = 5;

// Local storage keys
export const EXPLICIT_LOGOUT_STORAGE_KEY = "leo-ai.explicit-logout";

// `KeyboardEvent.key` values
export const KEYBOARD_KEY = {
  ENTER: "Enter",
  ESCAPE: "Escape",
};

// Durations in miliseconds
export const SECOND_MS = 1000;
export const MINUTE_MS = 60 * SECOND_MS;
export const HOUR_MS = 60 * MINUTE_MS;
export const DAY_MS = 24 * HOUR_MS;
export const WEEK_MS = 7 * DAY_MS;

export const DEFAULT_DELAY = 200;
